<template>
    <div class="elementor-element elementor-widget elementor-widget-form">
        <div class="elementor-widget-container">
            <div class="vehica-panel">
                <div class="vehica-panel-menu-desktop">
                    <div class="vehica-container">
                        <div class="vehica-panel-menu-desktop__inner">
                            <h1 class="vehica-panel-menu-desktop__title">
                                Account
                            </h1>
                            <div class="vehica-panel-menu-desktop__navbar">
                                <a href="/account" @click.prevent="show()" title="Profile" class="vehica-panel-menu-desktop__button vehica-panel-menu-desktop__button--active">
                                    <span>Profile</span>
                                </a>
                                <a href="/sell" title="Listings" class="vehica-panel-menu-desktop__button">
                                    <span>Listings</span>
                                </a>
                                <a href="/search?likes=true" title="Likes" class="vehica-panel-menu-desktop__button">
                                    <span>Likes</span>
                                </a>
                                <a href="/account/signout" @click.prevent="signout" class="vehica-panel-menu-desktop__button">
                                    <span>Sign Out</span>
                                </a>
                                <div class="vehica-panel-menu-desktop__avatar">
                                    <label href="" :class="profileImageClass" :style="profileImage">
                                        <input type="file" name="profileImageUpload" id="profileImageUpload" hidden="" accept="image/*" @change="onSelectedFile($event)">
                                    </label>
                                    <label for="profileImageUpload" title="Set new profile picture" class="vehica-panel-menu-desktop__avatar__icon">
                                    <i class="fas fa-camera"></i></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vehica-panel-menu-mobile">
                    <div class="vehica-panel-menu-mobile__inner">
                        <div class="vehica-panel-menu-mobile__avatar">
                            <a href="/account" title="My profile" class="vehica-panel-menu-mobile__avatar__image"></a>
                            <a href="" title="Set new profile picture" class="vehica-panel-menu-mobile__avatar__icon"><i class="fas fa-camera"></i></a>
                        </div>
                        <div class="vehica-panel-menu-mobile__navbar">
                            <div class="vehica-panel-menu-mobile__navbar__inner">
                                <a href="/account" @click.prevent="show()" title="Profile" class="vehica-panel-menu-mobile__button vehica-panel-menu-mobile__button--active">
                                    Profile
                                </a>
                                <a href="/sell" title="Listings" class="vehica-panel-menu-mobile__button">
                                    Listings
                                </a>
                                <a href="/search?likes=true" title="Likes" class="vehica-panel-menu-mobile__button">
                                    Likes
                                </a>
                                <a href="/account/signout" @click.prevent="signout" class="vehica-panel-menu-mobile__button">
                                    Sign Out
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vehica-container">
                    <div class="vehica-panel-list__top">
                        <div class="vehica-panel-list__statuses-wrapper">
                            <div class="vehica-panel-list__statuses">
                                <a href="/account/update" @click.prevent="show()" :class="listStatus(!showChangePassword)">
                                    Account Details
                                </a>
                                <a href="/account/change-password" @click.prevent="show('change-password')" :class="listStatus(showChangePassword)">
                                    Change Password
                                </a>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div v-if="!showChangePassword" class="vehica-panel-account">
                            <div class="vehica-panel-account__details-wrapper">
                                <div class="vehica-panel-account__details">
                                    <div class="vehica-panel-account__inner">
                                        <h3 class="vehica-panel-account__title">
                                            Your contact details
                                        </h3>
                                        <form @submit.prevent="submit">
                                            <div class="vehica-grid">
                                                <div class="vehica-grid__element--mobile-1of1 vehica-grid__element--tablet-1of1 vehica-grid__element--1of3">
                                                    <div class="vehica-panel-account-field">
                                                        <label for="firstname" class="vehica-panel-account-field__label">
                                                            First Name<span class="vehica-text-primary">*</span>
                                                        </label>
                                                        <input id="firstname" v-model="model.firstname" type="text" required="required" class="vehica-panel-account-field__text-control"
                                                               :disabled="loading"
                                                               @keypress="changed"
                                                               @change="changed">
                                                    </div>
                                                </div>
                                                <div class="vehica-grid__element--mobile-1of1 vehica-grid__element--tablet-1of1 vehica-grid__element--1of3">
                                                    <div class="vehica-panel-account-field">
                                                        <label for="lastname" class="vehica-panel-account-field__label">
                                                            Last Name<span class="vehica-text-primary">*</span>
                                                        </label>
                                                        <input id="lastname" v-model="model.lastname" type="text" required="required" class="vehica-panel-account-field__text-control"
                                                               :disabled="loading"
                                                               @keypress="changed"
                                                               @change="changed">
                                                    </div>
                                                </div>
                                                <div class="vehica-grid__element--mobile-1of1 vehica-grid__element--tablet-1of1 vehica-grid__element--1of3">
                                                    <div class="vehica-panel-account-field">
                                                        <label for="zipcode" class="vehica-panel-account-field__label">
                                                            Zip code
                                                        </label>
                                                        <input id="zipcode" v-model="model.zipcode" type="text" inputmode="numeric" class="vehica-panel-account-field__text-control"
                                                               @keypress="numberOnly"
                                                               @change="changed"
                                                               :disabled="loading">
                                                    </div>
                                                </div>
                                                <div class="vehica-grid__element--mobile-1of1 vehica-grid__element--tablet-1of1 vehica-grid__element--1of2">
                                                    <div class="vehica-panel-account-field">
                                                        <label for="phone" class="vehica-panel-account-field__label">
                                                            Phone
                                                        </label>
                                                        <input id="phone" v-model="model.phone" type="tel" inputmode="tel" class="vehica-panel-account-field__text-control"
                                                               @keypress="numberOnly"
                                                               @change="changed"
                                                               :disabled="loading">
                                                    </div>
                                                </div>
                                                <div class="vehica-grid__element--mobile-1of1 vehica-grid__element--tablet-1of1 vehica-grid__element--1of2">
                                                    <div class="vehica-panel-account-field vehica-panel-account-field--email">
                                                        <label for="email" class="vehica-panel-account-field__label">
                                                            Email
                                                        </label>
                                                        <input id="email" :value="model.email" type="text" inputmode="email" disabled class="vehica-panel-account-field__text-control">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-flex vehica-panel-account__button-save">
                                                <div v-if="false" class="align-content-center vehica-panel-account__delete">
                                                    Delete account
                                                </div>
                                                <span v-if="message" class="alert alert-success lh-lg mb-0 ms-auto p-2">{{message}}</span>
                                                <submit-button class-name="ms-auto me-3" :active="loading">Save</submit-button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="showChangePassword" class="vehica-panel-account">
                            <div class="vehica-panel-account__details-wrapper">
                                <div class="vehica-panel-account__details">
                                    <div class="vehica-panel-account__inner">
                                        <h3 class="vehica-panel-account__title">
                                            Change Password
                                        </h3>
                                        <div class="vehica-panel-account__change-password">
                                            <form @submit.prevent="changePassword">
                                                <div class="vehica-grid">
                                                    <div class="vehica-grid__element--mobile-1of1 vehica-grid__element--tablet-1of1 vehica-grid__element--1of2">
                                                        <div class="vehica-panel-account-field">
                                                            <label for="oldpassword" class="vehica-panel-account-field__label">
                                                                Current Password<span class="vehica-text-primary">*</span>
                                                            </label>
                                                            <input id="oldpassword" type="password" required="required" class="vehica-panel-account-field__text-control"
                                                                   v-model="password.password"
                                                                   @keypress="changed"
                                                                   @change="changed">
                                                        </div>
                                                    </div>
                                                    <div class="vehica-grid__element--mobile-1of1 vehica-grid__element--tablet-1of1 vehica-grid__element--1of2">
                                                        <div class="vehica-panel-account-field">
                                                            <label for="newpassword" class="vehica-panel-account-field__label">
                                                                New Password<span class="vehica-text-primary">*</span> (at least 10 characters)
                                                            </label>
                                                            <input id="newpassword" type="password" required="required" class="vehica-panel-account-field__text-control"
                                                                   v-model="password.newPassword"
                                                                   @keypress="changed"
                                                                   @change="changed">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex vehica-panel-account__button-save">
                                                    <span v-if="message" class="alert alert-success lh-lg mb-0 ms-auto p-2">{{message}}</span>
                                                    <submit-button class-name="ms-auto me-3" :active="loading">Save</submit-button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import Messages from '../common/Messages'
    import SubmitButton from '../common/fields/SubmitButton'

    export default {
        props: ['values'],
        components: {
            SubmitButton
        },
        data: function () {
            return {
                loading: true,
                message: '',
                model: {
                    firstname: '',
                    lastname: '',
                    zipcode: '',
                    email: '',
                    phone: '',
                    image: '',
                },
                password: {
                    password: '',
                    newPassword: '',
                },
                view: null,
            };
        },
        computed: {
            profileImage() {
                if (this.model.image) {
                    return { 'background-image': `url('${this.model.image}')` };
                }
                return null;
            },
            profileImageClass() {
                let c = 'vehica-panel-menu-desktop__avatar__image';
                if (!this.model.image) {
                    c += ' vehica-panel-menu-desktop__avatar__image--placeholder';
                }
                return c;
            },
            showChangePassword() {
                return this.view === 'change-password';
            },
        },
        methods: {
            changed() {
                this.message = '';
            },
            changePassword() {
                const vm = this;
                vm.loading = true;
                axios.post('/account/change-password', vm.password)
                    .then(r => {
                        if (r.data.success) {
                            vm.password.password = '';
                            vm.password.newPassword = '';
                            vm.message = r.data.message;
                        } else if (r.data.message) {
                            Messages.warning({ html: r.data.message });
                        }
                    })
                    .catch(e => {
                        Messages.warning();
                    }).finally(() => {
                        vm.loading = false;
                    });
            },
            listStatus(active) {
                return 'vehica-panel-list__status' + (active ? ' vehica-panel-list__status--active' : '');
            },
            numberOnly(event) {
                if (!event.keyCode || event.keyCode < 48 || event.keyCode > 57) {
                    event.preventDefault();
                }
                this.changed();
            },
            onSelectedFile(event) {
                const vm = this;
                const fileinput = event.target;
                const file = fileinput.files[0];
                if (file) {
                    if (!file.type.startsWith('image/')) {
                        Messages.warning({ html: 'The chosen file is not an accepted image format.' });
                        return;
                    }
                    if (file.size > 4194304) {
                        Messages.warning({ html: 'The chosen file is too large. The maximum file size accepted is 4MB' });
                        return;
                    }
                    const data = new FormData();
                    data.set('file', file);
                    axios.post('/account/picture', data, { headers: { 'Content-Type': 'multipart/form-data' } })
                        .then(
                            r => {
                                if (r.status === 200) {
                                    if (!r.data || r.data.error) {
                                        Messages.warning({ html: r.data?.error || 'Upload failed!' });
                                        vm.uploadVideoError = r.data?.error || 'Upload failed!';
                                    } else {
                                        vm.model.image = r.data.url;
                                    }
                                } else {
                                    Messages.warning({ html: r.data?.error || 'Upload failed!' });
                                }
                            },
                            e => {
                                if (!axios.isCancel(e)) {
                                    Messages.warning({
                                        html: e.response?.data?.message || e.message || 'Upload failed!'
                                    });
                                }
                            }
                        )
                        .finally(() => {
                            fileinput.value = '';
                        });
                }
            },
            show(view) {
                this.changed();
                this.view = view ?? null;
            },
            signout() {
                Events.signout();
            },
            submit() {
                const vm = this;
                vm.loading = true;
                axios.post('/account/update', this.model)
                    .then(r => {
                        if (r.data.success) {
                            vm.message = r.data.message;
                        } else if (r.data.message) {
                            Messages.warning({ html: r.data.message });
                        }
                    })
                    .catch(e => {
                        Messages.warning();
                    }).finally(() => {
                        vm.loading = false;
                    });
            }
        },
        created() {
        },
        mounted() {
            Object.assign(this.model, this.values);
            this.loading = false;
        }
    }
</script>